import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiCheck, FiX, FiLoader, FiAlertCircle, FiCheckCircle } from "react-icons/fi";
import { SERVER_URL } from "../../../databucket";

const BotActionCard = ({ message, conversationId }) => {
  const dispatch = useDispatch();
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const [executing, setExecuting] = useState(false);

  const action = message.embeddedAction;
  if (!action || !action.actionType) return null;

  const isPending = !action.result || action.result === 'pending';
  const isSuccess = action.result === 'success';
  const isFailed = action.result === 'failed';

  const handleExecute = async (actionOverride) => {
    if (executing) return;
    setExecuting(true);

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      await fetch(`${SERVER_URL}/api/bot/execute-action`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          messageId: message.id,
          actionType: actionOverride || action.actionType,
          entityType: action.entityType,
          entityId: action.entityId,
          payload: action.payload,
          userId: loginUser?.id,
        }),
      });
    } catch (err) {
      console.error("Action execution error:", err);
    }
    setExecuting(false);
  };

  // Approval action card
  if (action.actionType === 'approveLeave' || action.actionType === 'rejectLeave') {
    return (
      <div className={`action-card ${isPending ? 'action-card--pending' : isSuccess ? 'action-card--success' : 'action-card--failed'}`}>
        <div className="action-card__header">
          {isPending ? <FiAlertCircle size={14} className="action-card__icon--pending" /> :
           isSuccess ? <FiCheckCircle size={14} className="action-card__icon--success" /> :
           <FiX size={14} className="action-card__icon--failed" />}
          <span className="action-card__type">
            {action.actionType === 'approveLeave' ? 'Leave Approval' : 'Leave Decision'}
          </span>
        </div>

        {action.resultMessage && (
          <div className={`action-card__result ${isSuccess ? 'action-card__result--success' : 'action-card__result--failed'}`}>
            {action.resultMessage}
          </div>
        )}

        {isPending && (
          <div className="action-card__buttons">
            <button
              onClick={() => handleExecute('approveLeave')}
              disabled={executing}
              className="action-card__btn action-card__btn--approve"
              type="button"
            >
              {executing ? <FiLoader className="ai-panel__spinner" size={12} /> : <FiCheck size={12} />}
              Approve
            </button>
            <button
              onClick={() => handleExecute('rejectLeave')}
              disabled={executing}
              className="action-card__btn action-card__btn--reject"
              type="button"
            >
              <FiX size={12} /> Reject
            </button>
          </div>
        )}
      </div>
    );
  }

  // Generic action result card
  if (isSuccess || isFailed) {
    return (
      <div className={`action-card ${isSuccess ? 'action-card--success' : 'action-card--failed'}`}>
        <div className="action-card__header">
          {isSuccess ? <FiCheckCircle size={14} className="action-card__icon--success" /> :
           <FiX size={14} className="action-card__icon--failed" />}
          <span className="action-card__type">{formatActionType(action.actionType)}</span>
        </div>
        {action.resultMessage && (
          <div className={`action-card__result ${isSuccess ? 'action-card__result--success' : 'action-card__result--failed'}`}>
            {action.resultMessage}
          </div>
        )}
      </div>
    );
  }

  return null;
};

function formatActionType(type) {
  const map = {
    assignLead: 'Lead Assignment',
    updateLeadStatus: 'Status Update',
    markComplete: 'Completion',
    approveLeave: 'Leave Approval',
    rejectLeave: 'Leave Rejection',
    updateRequestStatus: 'Status Update',
    assignRequest: 'Request Assignment',
  };
  return map[type] || type;
}

export default BotActionCard;
